exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-campaign-template-js": () => import("./../../../src/templates/campaignTemplate.js" /* webpackChunkName: "component---src-templates-campaign-template-js" */),
  "component---src-templates-campaigns-by-category-template-js": () => import("./../../../src/templates/campaignsByCategoryTemplate.js" /* webpackChunkName: "component---src-templates-campaigns-by-category-template-js" */)
}

